var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.4583L3 8.45825M3 8.45825L10 1.45825L17 8.45825M3 8.45825V18.4583C3 18.7235 3.10536 18.9778 3.29289 19.1654C3.48043 19.3529 3.73478 19.4583 4 19.4583H7M17 8.45825L19 10.4583M17 8.45825V18.4583C17 18.7235 16.8946 18.9778 16.7071 19.1654C16.5196 19.3529 16.2652 19.4583 16 19.4583H13M7 19.4583C7.26522 19.4583 7.51957 19.3529 7.70711 19.1654C7.89464 18.9778 8 18.7235 8 18.4583V14.4583C8 14.193 8.10536 13.9387 8.29289 13.7511C8.48043 13.5636 8.73478 13.4583 9 13.4583H11C11.2652 13.4583 11.5196 13.5636 11.7071 13.7511C11.8946 13.9387 12 14.193 12 14.4583V18.4583C12 18.7235 12.1054 18.9778 12.2929 19.1654C12.4804 19.3529 12.7348 19.4583 13 19.4583M7 19.4583H13",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.c69a0d82d997274c5dd428402d384ff4.svg";
export { ForwardRef as ReactComponent };